// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./font/DejaVuSansMono.ttf");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ":root{--font-size-base:16px}@media screen and (min-width:1920px){:root{--font-size-base:18px}}@media screen and (max-width:1024px){:root{--font-size-base:14px}}@font-face{font-weight:400;font-family:DejaVuSansMono;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}.clickable{cursor:pointer}", ""]);
// Exports
module.exports = exports;
